// Mirrors backend App\Enums\Order\OrderLogActionType

export type OrderLogActionType =
  | 'status_change'
  | 'date_change'
  | 'time_change'
  | 'cancellation'
  | 'payment_status_change'
  | 'order_type_change'
  | 'field_update'
  | 'created'
  | 'updated'
  | 'deleted'
  | 'payment_adjusted'

export const OrderLogActionType = {
  STATUS_CHANGE: 'status_change',
  DATE_CHANGE: 'date_change',
  TIME_CHANGE: 'time_change',
  CANCELLATION: 'cancellation',
  PAYMENT_STATUS_CHANGE: 'payment_status_change',
  ORDER_TYPE_CHANGE: 'order_type_change',
  FIELD_UPDATE: 'field_update',
  CREATED: 'created',
  UPDATED: 'updated',
  DELETED: 'deleted',
  PAYMENT_ADJUSTED: 'payment_adjusted'
} satisfies Record<string, OrderLogActionType>

export const OrderLogActionTypeValues: readonly OrderLogActionType[] =
  Object.values(OrderLogActionType)
